<template>
  <v-card :style="cardClass" class="ma-3">
    <chart
      type="radial-bar"
      :data="newData"
      :labels="chartData.labels"
      :total="newTotal"
      elevation="0"
      :title="title"
      width="auto"
      :id="
        'radial-chart-' +
          title
            .toLowerCase()
            .split(' ')
            .slice(3, 5)
            .join('-')
      "
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import Chart from '@/components/charts/Chart';
import { MobileView } from '@/mixins';

export default {
  components: {
    Chart,
  },
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      chartData: 'home/getOneWayVsRoundTrip',
      client: 'account/getCurrentClient',
    }),
    cardClass() {
      if (this.showMobileView) {
        return 'padding-bottom:10px;';
      }
      return 'overflow:hidden; min-height:100%; width:100%;';
    },
    chartWidth() {
      if (this.showMobileView) {
        return '';
      }
      return '500px';
    },
    newData() {
      let total = 0;
      for (let i = 0; i < this.chartData.data.length; i++) {
        total += this.chartData.data[i];
      }
      const percentage = total / 100;
      const new1way = this.chartData.data[0] / percentage;
      const newRound = this.chartData.data[1] / percentage;
      return [new1way.toFixed(), newRound.toFixed()];
    },
    newTotal() {
      let total = 0;
      for (let i = 0; i < this.chartData.data.length; i++) {
        total += this.chartData.data[i];
      }
      total = total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return total;
    },
    title() {
      if (this.client.client_name === 'bazzbi') {
        return 'QR Codes vs. Digital Keys';
      }
      if (this.client.client_name === 'avis') {
        return 'One Way vs. Round Trip';
      }
      return 'Bluetooth vs. Premium';
    },
  },
};
</script>

<style></style>
